"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradeSummary = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var StringManipulater_1 = require("@CommonFrontend/Utils/StringManipulater");
var Telemetry_1 = require("Common/Telemetry/Telemetry");
var DiscoverStore_1 = __importDefault(require("Discover/DiscoverStore"));
var inversify_react_1 = require("inversify-react");
var react_1 = __importDefault(require("react"));
var c = (0, BemBuilder_1.default)("trial-upgrade");
var UpgradeSummary = (function (_super) {
    __extends(UpgradeSummary, _super);
    function UpgradeSummary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleUpgrade = function () {
            _this.telemetry.track("Upgrade Prompt Viewed", { upgrade_prompt_view_origin: "discover pill" });
            _this.discoverStore.upgradeTrialAccount();
        };
        return _this;
    }
    Object.defineProperty(UpgradeSummary.prototype, "daysRemaining", {
        get: function () {
            var _a;
            var days = (_a = this.trial.daysRemaining()) !== null && _a !== void 0 ? _a : 0;
            return Math.max(days, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UpgradeSummary.prototype, "percentRemaining", {
        get: function () {
            var total = this.trial.daysInTrialPeriod();
            if (total !== null && total > 0) {
                return (this.daysRemaining / total) * 100;
            }
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    UpgradeSummary.prototype.render = function () {
        return (react_1.default.createElement("div", { className: c() },
            react_1.default.createElement("div", { className: c("row") },
                react_1.default.createElement("div", { className: c("time-remaining") },
                    react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s" }, "Free trial"),
                    " ",
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" },
                        (0, StringManipulater_1.pluralise)(this.daysRemaining, "day"),
                        " remaining")),
                react_1.default.createElement("button", { className: c("upgrade-button"), onClick: this.handleUpgrade },
                    react_1.default.createElement(icons_1.Upgrade, { className: c("upgrade-icon") }),
                    react_1.default.createElement(kaleidoscope_1.Label, { size: "m" }, "Upgrade"))),
            react_1.default.createElement("div", { className: c("progress") },
                react_1.default.createElement("div", { className: c("progress", "filled"), style: { width: "".concat(this.percentRemaining, "%") } }))));
    };
    var _a, _b;
    __decorate([
        (0, inversify_react_1.resolve)("trial"),
        __metadata("design:type", Object)
    ], UpgradeSummary.prototype, "trial", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("telemetry"),
        __metadata("design:type", typeof (_a = typeof Telemetry_1.Telemetry !== "undefined" && Telemetry_1.Telemetry) === "function" ? _a : Object)
    ], UpgradeSummary.prototype, "telemetry", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("discoverStore"),
        __metadata("design:type", typeof (_b = typeof DiscoverStore_1.default !== "undefined" && DiscoverStore_1.default) === "function" ? _b : Object)
    ], UpgradeSummary.prototype, "discoverStore", void 0);
    return UpgradeSummary;
}(react_1.default.Component));
exports.UpgradeSummary = UpgradeSummary;
